import EventPage from './EventPage.jsx';

export default EventPage;
